// src/features/services/media/components/Dashboard_media_youtube.tsx
import React from 'react';
import { useAuth } from '@/shared/auth';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import AudioLibraryPlayerYoutube from './AudioLibraryPlayer_youtube';

const Dashboard_media_youtube: React.FC = () => {
  const { can } = useAuth();
  useDocumentTitle('Media', 'YouTube');

  if (!can('media.library.view')) {
    return (
      <section className="p-6">
        <div className="rounded-lg bg-red-950/40 p-4 text-red-300">
          You do not have permission to view the Media module.
        </div>
      </section>
    );
  }

  return (
  <section className="pt-1 md:pt-2 px-2 md:px-3 pb-2 md:pb-3 space-y-2 h-full min-h-0 flex flex-col">
      <header />
      <div className="flex-1 min-h-0">
        <AudioLibraryPlayerYoutube />
      </div>
    </section>
  );
};

export default Dashboard_media_youtube;
